import DataStoreRequestFilter from "./DataStoreRequestFilter";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Button, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Box, Stack } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setIsPaginationOrSearchClicked,
  setSelectedQueryName,
} from "../../../../features/dataStoreReqSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

const DataStoreRequestFilterCard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { quaryContent, selectedQueryName } = useSelector(
    (state: any) => state.dataStoreReq
  );
  const response = useSelector(selectUserData);

  const uniqueQueryOptions = [
    ...new Map(quaryContent?.map((item: any) => [item?.id, item])).values(),
  ];
  const dispatch = useDispatch();
  const hasDataStoreCreatePermission = CheckPermissions(
    response?.data?.products?.admin,
    "datastore_requests",
    "create_datastore_requests"
  );
  const navigate = useNavigate();

  const handleClickOpen = () => {
    const currentParams = new URLSearchParams(window.location.search);
    navigate({
      pathname: "/admin/datastore_requests/create_query",
      search: currentParams.toString(),
    });
  };

  useEffect(() => {
    const search = searchParams.get("search");
    if (search) {
      dispatch(setSelectedQueryName(search));
    }
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ width: "100%" }}
    >
      <Stack direction="row" gap={2} alignItems={"center"}>
        <Autocomplete
          disablePortal
          size="small"
          options={uniqueQueryOptions || []}
          data-tracker="238"
          getOptionLabel={(option: any) => {
            if (!option) return "";
            return `${option.name} (${option.id})`;
          }}
          value={
            uniqueQueryOptions.find(
              (item: any) => item.name === selectedQueryName
            ) || null
          }
          onChange={(_, value: any) => {
            if (value) {
              dispatch(setSelectedQueryName(value.name)); // or store whole object if preferred
              setSearchParams((prevParams) => {
                const newParams = new URLSearchParams(prevParams);
                newParams.set("search", value.name);
                newParams.set("id", value.id);
                newParams.set("page", "0");
                dispatch(setIsPaginationOrSearchClicked(false));
                return newParams;
              });
            } else {
              dispatch(setSelectedQueryName(null));
              setSearchParams((prevParams) => {
                const newParams = new URLSearchParams(prevParams);
                newParams.delete("search");
                newParams.delete("id");
                dispatch(setIsPaginationOrSearchClicked(true));
                return newParams;
              });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Query Name or ID"
              value={""}
              sx={{ width: "300px" }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
        />
        <Box data-tracker="238">
          <DataStoreRequestFilter />
        </Box>
      </Stack>
      {hasDataStoreCreatePermission ? (
        <Button
          onClick={handleClickOpen}
          variant="contained"
          color="secondary"
          endIcon={<AddIcon />}
          data-tracker="243"
        >
          Add New Request
        </Button>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          endIcon={<AddIcon />}
          disabled
        >
          Add New Request
        </Button>
      )}
    </Stack>
  );
};

export default DataStoreRequestFilterCard;
